import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import Tooltip from '@mui/material/Tooltip';

import { FontAwesomeSvgIcon } from 'components/shared';

export default function ShowWarning() {
  const { t } = useTranslation('common');

  return (
    <Tooltip title={t('noActionSelected') || ''} arrow disableInteractive>
      <FontAwesomeSvgIcon
        icon={faExclamationTriangle}
        fontSize="small"
        color="warning"
        className="warning-icon"
      />
    </Tooltip>
  );
}
